<template>
  <blank-card :height="height">
    <div>
      <span class="title block">{{ title }}</span>
      <ul class="pt-5">
        <div
          v-for="item in items"
          class="grid grid-cols-2"
        >
          <slot :item="item" />
        </div>
      </ul>
    </div>
  </blank-card>
</template>

<script>
import BlankCard from '@/Components/Cards/BlankCard'
import DownArrow from '@/Components/Icons/DownArrow'
import { ArrowSmUpIcon } from '@heroicons/vue/solid'
import { ArrowSmDownIcon } from '@heroicons/vue/solid'

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    },
    height: {
      type: String,
      default: null
    }
  },
  components: { BlankCard }
}
</script>
